// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ae199731","769":"b98d9561"}[chunkId] + ".chunk.js";
};